import state from './moduleItemState.js'
import mutations from './moduleItemMutations.js'
import actions from './moduleItemActions.js'
import getters from './moduleItemGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}